import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import TemporaryScheduleAPI from '@/api/temporarySchedule/api-temporary-schedule';
// import TemporaryScheduleAPI from '../../../src/api/temporarySchedule/api-temporary-schedule';

// ================== Thunks ==================
export const fetchTemporarySchedules = createAsyncThunk(
  'temporarySchedule/fetchTemporarySchedules',
  async (_, thunkAPI) => {
    try {
      const response = await TemporaryScheduleAPI.getAll();
      return response?.data?.data ?? [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const addTemporarySchedule = createAsyncThunk(
  'temporarySchedule/addTemporarySchedule',
  async (payload, thunkAPI) => {
    try {
      const response = await TemporaryScheduleAPI.add(payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateTemporarySchedule = createAsyncThunk(
  'temporarySchedule/updateTemporarySchedule',
  async (payload, thunkAPI) => {
    try {
      const response = await TemporaryScheduleAPI.update(payload.id, payload);
      return response.data.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteTemporarySchedule = createAsyncThunk(
  'temporarySchedule/deleteTemporarySchedule',
  async (ids, thunkAPI) => {
    try {
      await TemporaryScheduleAPI.delete(ids); // pass single or multiple IDs
      return ids; // return single ID or array of IDs
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

// ================== Initial State ==================
const initialState = {
  list: [],
  loading: false,
  error: '',
};

// ================== Slice ==================
const temporaryScheduleSlice = createSlice({
  name: 'temporarySchedule',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // ---- Fetch ----
      .addCase(fetchTemporarySchedules.pending, (state) => {
        state.loading = true;
        state.error = '';
      })
      .addCase(fetchTemporarySchedules.fulfilled, (state, action) => {
        state.loading = false;
        state.list = [...action.payload];
      })
      .addCase(fetchTemporarySchedules.rejected, (state, action) => {
        state.loading = false;
        state.list = [];
        state.error = action.payload ?? 'An error occurred';
      })

      // ---- Add ----
      .addCase(addTemporarySchedule.fulfilled, (state, action) => {
        state.list.unshift(action.payload);
      })

      // ---- Update ----
      .addCase(updateTemporarySchedule.fulfilled, (state, action) => {
        const index = state.list.findIndex(
          (item) => item.id === action.payload.id
        );
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })

      // ---- Delete ----
      .addCase(deleteTemporarySchedule.fulfilled, (state, action) => {
        const idsToDelete = Array.isArray(action.payload)
          ? action.payload
          : [action.payload];

        state.list = state.list.filter(
          (item) => !idsToDelete.includes(item.id)
        );
      });
  },
});

export default temporaryScheduleSlice.reducer;
